import { z } from "zod";

export const LedgerEntrySchema = z.object({
  id: z.string(),
  billErpSyncEntryId: z.string().nullish(),
  achLoadErpSyncEntryId: z.string().nullish(),
  billPaymentErpSyncEntryId: z.string().nullish(),
  createdAt: z.preprocess(
    (val) => (val instanceof Date ? val.toISOString() : val),
    z.string().datetime(),
  ),
  erpVendorId: z.string().nullish(),
  erpVendorName: z.string().nullish(),
  invoiceNumber: z.string().nullish(),
  amount: z.number(),
  transactionDate: z.string(),
  erpId: z.string().nullish(),
  type: z.enum(["BILL", "ACH_LOAD", "ACH_LOAD_REVERSAL", "BILL_PAYMENT"]),
  link: z.string().nullish(),
  erpIntegration: z.enum(["QUICKBOOKS", "NETSUITE"]),
  errors: z.array(z.string()),
});

export type LedgerEntry = z.infer<typeof LedgerEntrySchema>;
